<h2 class="mbottom-12">{{ 'commercialCommon.paymentMethodSelectionCommon.selectPaymentMethod' | transloco }}</h2>
<div *ngFor="let paymentMethod of paymentMethods; let i = index; trackBy: trackPaymentMethod" class="row mbottom-12">
  <div class="col-12">
    <yat-payment-method-panel
      [id]="'49676c61-17b7-4ec1-89a8-580228e1ce0c-' + i"
      [paymentMethod]="paymentMethod"
      [defaultIcon]="isSelected(paymentMethod) ? 'selected' : null"
      [showDeleteIcon]="
        (paymentMethod | isPaymentMethodOrBillingAddressDeletable: updateSubscriptionWithContractId) && !(isUsed(paymentMethod) && !allowToDeleteUsed)
      "
      [showEditIcon]="paymentMethod | isPaymentMethodOrBillingAddressEditable: updateSubscriptionWithContractId"
      [liveLicense]="(isLive$ | async) ?? true"
      (selectMethod)="select(paymentMethod, $event)"
      (prepareDeleteMethod)="prepareDelete(paymentMethod)"
      (cancelDeleteMethod)="cancelDelete()"
      (deleteMethod)="delete(paymentMethod, $event)"
      (editMethod)="editSelectedPaymentMethod(paymentMethod)"
      (modalClosed)="modalClosed()"
      [samePaymentMethodSelected]="(samePaymentMethodSelected$ | async) ?? true"
      [matomoEventClickAction]="isSelected(paymentMethod) ? '' : 'Select_PaymentMethod'">
    </yat-payment-method-panel>
  </div>
</div>
<p *ngIf="paymentMethods.length === 0" class="mbottom-12">{{ 'commercialCommon.paymentMethodSelectionCommon.noPaymentMethods' | transloco }}</p>
<a
  *ngIf="(isLive$ | async) && (canPaymentMethodsBeCreated$ | async)"
  yat-link
  class="link link-secondary"
  routerLink="../add-payment-method"
  [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
  matomoClickAction="Submit_AdditionalPaymentMethod"
  matomoClickName="AddAdditionalPaymentMethodLink"
  ><yat-icon id="3cf23027-5871-4f89-bcfe-204320823637" name="plus-circle-duo" class="mr-1"></yat-icon>{{ 'commercialCommon.paymentMethodSelectionCommon.addNewPaymentMethod' | transloco }}</a
>

<ng-container *yatVar="walletButtonsTemplate && isWalletButtonAllowed(stashedWallet, (allowedPaymentMethods$ | async) ?? []) as showWallet">
  <div class="row mt-4" *ngIf="showWallet">
    <div class="col-12">
      <ng-container *ngTemplateOutlet="walletButtonsTemplate ?? null; context: { $implicit: stashedWallet }"></ng-container>
    </div>
  </div>
  <div class="row" [class.mt-2]="showWallet" [class.mt-4]="!showWallet">
    <div class="col-12">
      <button
        yat-button
        type="button"
        [class.primary]="!stashedWallet"
        [class.secondary-weak]="stashedWallet"
        class="btn btn-large w-100"
        (click)="continue()"
        [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PAYMENT"
        matomoClickAction="Confirm_PaymentMethodSelection"
        matomoClickName="Continue">
        {{ (showWallet ? 'back' : 'continue') | commonWording | async }}
      </button>
    </div>
  </div>
</ng-container>
